import React from 'react';

const Separator = () => <div role="separator" className="divider"></div>;
export default Separator;
